import React from "react";
import { Phone, Mail, MapPin, ArrowRight, CalendarCheck } from "lucide-react";
import { Seo } from "@/components/Seo";
import { useLead } from "@/context/LeadContext";
import { useBooking } from "@/context/BookingContext";
import { AnimatedLines } from "@/components/landing/AnimatedLines";
import logoFull from "@/assets/logo-full.png";
import { CONTACT } from "@/data/pages";

export default function Devis() {
  const { openForm } = useLead();
  const { openBooking } = useBooking();
  return (
    <div data-testid="devis-page">
      <Seo
        title="Devis gratuit — Nettoyage & Detailing | MARTIN NETTOYAGE"
        description="Demandez votre devis gratuit pour un nettoyage auto, habitat ou professionnel. Réponse rapide à Belfort, Montbéliard, Héricourt."
        path="/devis"
      />
      <section className="relative overflow-hidden px-5 md:px-8 py-16 lg:py-24">
        <AnimatedLines />
        <div className="relative z-10 max-w-4xl mx-auto text-center">
        <img src={logoFull} alt="MARTIN NETTOYAGE" className="h-24 w-auto mx-auto mb-8" />
        <h1 className="font-heading font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-ink">
          Demandez votre devis gratuit
        </h1>
        <p className="text-muted-foreground mt-5 text-base sm:text-lg max-w-2xl mx-auto">
          Décrivez votre besoin, nous revenons vers vous rapidement : devis sous 24h pour les urgences, 48h pour les demandes classiques.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <button
            data-testid="devis-cta"
            onClick={() => openForm("auto")}
            className="cta inline-flex items-center gap-2 bg-ink text-white font-bold px-8 py-4 rounded-sm hover:bg-ink-light"
          >
            Ouvrir le formulaire de devis <ArrowRight className="w-5 h-5" />
          </button>
          <button
            data-testid="devis-book"
            onClick={openBooking}
            className="cta inline-flex items-center gap-2 bg-royal text-white font-extrabold px-8 py-4 rounded-sm hover:bg-royal-hover shadow-lg shadow-royal/30"
          >
            <CalendarCheck className="w-5 h-5" /> Réserver mon créneau
          </button>
        </div>

        <div className="grid sm:grid-cols-3 gap-4 mt-14 text-left">
          <a href={CONTACT.phoneHref} className="bg-marble-light border border-border rounded-sm p-6 lift">
            <Phone className="w-6 h-6 text-ink" />
            <div className="font-heading font-bold text-ink mt-3">Téléphone</div>
            <div className="text-sm text-muted-foreground mt-1">{CONTACT.phone}</div>
          </a>
          <a href={`mailto:${CONTACT.quoteEmail}`} className="bg-marble-light border border-border rounded-sm p-6 lift">
            <Mail className="w-6 h-6 text-ink" />
            <div className="font-heading font-bold text-ink mt-3">Email devis</div>
            <div className="text-sm text-muted-foreground mt-1 break-all">{CONTACT.quoteEmail}</div>
          </a>
          <div className="bg-marble-light border border-border rounded-sm p-6">
            <MapPin className="w-6 h-6 text-ink" />
            <div className="font-heading font-bold text-ink mt-3">Zone</div>
            <div className="text-sm text-muted-foreground mt-1">{CONTACT.area}</div>
          </div>
        </div>
        </div>
      </section>
    </div>
  );
}